import React, { useState, useEffect, FC } from "react";
import { Icon, TooltipComponent } from "../../components/Component";
import FormatDate from "../masters/DateFormater";
import RateContractAside from "./RateContractAside";
import Swal from "sweetalert2";
import purchaseOrderApis from "../../api/master/PurchaseOrder";
import { useNavigate } from "react-router";
import statusMapper from "./StatusMapper";
import { formatCurrency } from "../../utils/Utils";
import TransactionFlowDefaultTemplate from "../others/transactionFlowDefaultTemplate";
import { useSelector } from "react-redux";

const ViewRateContractsList: FC = () => {
  const navigate = useNavigate();
  const [sm, setSm] = useState(false);
  const [widgetData, setWidgetData] = useState<any>({});
  const [orderStatus, setOrderStatus] = useState<any>([]);
  const { data: currentUser } = useSelector((state: any) => state.currentUser);
  const [siteOptions, setSiteOptions] = useState<any>([]);
  const columns = [
    {
      title: "Contract #",
      dataIndex: "orderId",
      key: "orderId",
      width: 200,
      fixed: "left",
      render(text: any, record: any) {
        return (
          <>
            <span
              className="inlineTableCellLink"
              id={`draftStatus-${record?.orderNumber}`}
              onClick={() => {
                if (record?.orderStatus == "Draft") {
                  navigate(`/rate-contract-new/`, {
                    state: {
                      draftId: record?.orderNumber,
                    },
                  });
                } else {
                  navigate(`/view-rate-contract/${49497}`, {
                    state: {
                      status: record?.orderStatus,
                    },
                  });
                }
              }}
            >
              {text}
            </span>
            <TooltipComponent
              iconClass="info-circle text-info"
              icon={record?.orderStatus == "Draft" ? "info" : ""}
              id={`draftStatus-${record?.orderNumber}`}
              direction="right"
              text={
                record?.orderStatus == "Draft"
                  ? "Click To Continue Order Creation"
                  : "Click To View Order Details"
              }
              containerClassName={"mt-1"}
            />
          </>
        );
      },
    },
    {
      title: "Contract Date",
      dataIndex: "orderDate",
      key: "orderDate",
      width: 150,
      fixed: "left",
      render: (date: any) => <span>{FormatDate(date)}</span>,
    },
    {
      title: "Supplier Name ",
      dataIndex: "supplierName",
      key: "supplierName",
      width: 250,
      render: (text: string, record: any, index: any) => {
        return (
          <>
            <span id={`supplierName-tooltip-${index}`}>
              {text?.length > 25 ? `${text?.substring(0, 22)}... ` : text}
            </span>
            {text?.length > 25 && (
              <TooltipComponent
                iconClass="info-circle text-info"
                icon="info"
                id={`supplierName-tooltip-${index}`}
                direction="top"
                text={text}
                containerClassName={""}
              />
            )}
          </>
        );
      },
    },
    {
      title: "Site",
      dataIndex: "siteName",
      key: "siteName",
      width: 200,
    },
    {
      title: "Start Date",
      dataIndex: "needByDate",
      key: "needByDate",
      width: 200,
      render: (date: any) => <span>{date ? FormatDate(date) : "N/A"}</span>,
    },
    {
      title: "End Date",
      dataIndex: "needByDate",
      key: "needByDate",
      width: 200,
      render: (date: any) => <span>{date ? FormatDate(date) : "N/A"}</span>,
    },
    {
      title: "Created By",
      dataIndex: "createdUserName",
      key: "createdUserName",
      width: 200,
    },
    {
      title: "Created Date",
      dataIndex: "createdDate",
      key: "createdDate",
      render: (date: any) => <span>{FormatDate(date)}</span>,
      width: 150,
    },
    {
      title: "Status",
      dataIndex: "orderStatus",
      key: "orderStatus",
      width: 200,
      fixed: "right",
      render: (status: any) => {
        const _status = statusMapper[status]?.buyer;
        return (
          <div className="justify-start align-center">
            <h6
              className={`tb-status ms-1`}
              style={{
                color: `${_status?.color}`,
                fontSize: "14px",
              }}
            >
              {_status?.icon} {_status?.title || status}
            </h6>
          </div>
        );
      },
    },
    // {
    //   title: "Action",
    //   key: "operation",
    //   fixed: "right",
    //   width: 150,
    //   render: (text: any, record: any, index: any) => (
    //     <>
    //       <Button
    //         size="sm"
    //         // color=""
    //         onClick={() => {
    //           navigate(`/poHistory/${record.orderNumber}`);
    //         }}
    //       >
    //         <Icon name="history" title="View Version History" />
    //       </Button>
    //     </>
    //   ),
    // },
  ];

  useEffect(() => {
    fetchWidgetCount();
    fetchDerivedOrderStatusDropdown();
  }, []);

  const fetchWidgetCount = async () => {
    try {
      const res = await purchaseOrderApis.fetchWidgetCount();
      const { data, status, message } = res;
      if (status) {
        setWidgetData(data);
      } else {
        Swal.fire("Error", message, "error");
      }
    } catch (error) {}
  };

  const fetchDerivedOrderStatusDropdown = async () => {
    try {
      const res = await purchaseOrderApis.fetchDerivedOrderStatusDropdown();
      const { data, status, message } = res;
      if (status) {
        let dateresp = Object.keys(data).map((key) => {
          return {
            label: key,
            value: data[key],
          };
        });
        setOrderStatus(dateresp);
      } else {
        Swal.fire("Error", message, "error");
      }
    } catch (error) {}
  };

  useEffect(() => {
    if (currentUser) {
      const { siteAccessibility } = currentUser;
      if (siteAccessibility) {
        const allSites: any = [];
        const _siteOptions: any = [];
        siteAccessibility?.forEach((item: any) => {
          allSites.push(item.siteID);
          _siteOptions.push({ label: item.siteName, value: item.siteID });
        });
        setSiteOptions([..._siteOptions]);
      }
    }
  }, [currentUser]);

  return (
    <TransactionFlowDefaultTemplate
      moduleKey="view-tender-order"
      title="Rate Contract"
      columns={columns}
      sideNavigation={
        <div
          className={`card-aside card-aside-left user-aside toggle-slide toggle-slide-left toggle-break-lg ${
            sm ? "content-active" : ""
          }`}
        >
          <RateContractAside updateSm={setSm} sm={sm} />
        </div>
      }
      selectFilters={[
        {
          title: "Status",
          placeholder: "Select Status",
          options: orderStatus,
        },
        {
          title: "Site",
          options: siteOptions,
          selectionMode: "multiple",
        },
      ]}
      extra={{
        tableScrollX: 1100,
        dateRange: true,
        excelExport: true,
        dataFilterTootip: "Filtering based on Rate Contract date",
      }}
      // topRightJSX={
      //   <Button color="primary" onClick={() => excelExport()}>
      //     <Icon name="download"></Icon>
      //     <span>Excel Export </span>
      //   </Button>
      // }
      widget={{
        isActive: true,
        progressCircle: false,
        list: [
          {
            title: "Active Contracts",
            key: "approved",
            color: "#OO65BD",
            percentage: `${widgetData?.approvedPercentage || 0}`,
            value: `25`,
          },
          {
            title: "InActive Contracts",
            key: "pending",
            color: "#20639B",
            percentage: `${widgetData?.pendingApprovalPercentage || 0}`,
            value: `30`,
          },
          {
            title: "Expired Contracts",
            key: "supplierChanges",
            color: "#FA991C",
            percentage: `${widgetData?.supplierChangesPercentage || 0}`,
            value: `35`,
          },
          {
            title: "Expiry in Next 30 Days",
            key: "changesRequested",
            color: "#FA991C",
            percentage: `${widgetData?.changesRequestedPercentage || 0}`,
            value: `10`,
          },
          {
            title: "Expiry in Next 45 Days",
            key: "toBeInvoiced",
            color: "#FA991C",
            percentage: `${widgetData?.tobeInvoicedPercentage || 0}`,
            value: `10`,
          },
        ],
      }}
    />
  );
};

export default ViewRateContractsList;
